import React from "react";

export default function SuccessGreenIcon() {
  return (
    <>
      <svg
        width="60"
        height="59"
        viewBox="0 0 60 59"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M37.6235 3.21107C33.4428 -1.07036 26.5572 -1.07036 22.3765 3.21107L20.0835 5.5594L16.8015 5.52031C10.8179 5.44904 5.94904 10.3179 6.02031 16.3015L6.0594 19.5835L3.71107 21.8765C-0.570356 26.0572 -0.570356 32.9428 3.71107 37.1235L6.0594 39.4165L6.02031 42.6985C5.94904 48.682 10.818 53.551 16.8015 53.4797L20.0835 53.4406L22.3765 55.7889C26.5572 60.0704 33.4428 60.0704 37.6235 55.7889L39.9165 53.4406L43.1985 53.4797C49.182 53.551 54.051 48.682 53.9797 42.6985L53.9406 39.4165L56.2889 37.1235C60.5704 32.9428 60.5704 26.0572 56.2889 21.8765L53.9406 19.5835L53.9797 16.3015C54.051 10.318 49.182 5.44904 43.1985 5.52031L39.9165 5.5594L37.6235 3.21107ZM38.6787 25.2725L27.6162 36.335C27.2705 36.6807 26.8015 36.875 26.3125 36.875C25.8235 36.875 25.3545 36.6807 25.0088 36.335L19.4775 30.8037C18.7575 30.0837 18.7575 28.9163 19.4775 28.1963C20.1975 27.4762 21.365 27.4762 22.085 28.1963L26.3125 32.4238L36.0713 22.665C36.7913 21.945 37.9587 21.945 38.6787 22.665C39.3988 23.385 39.3988 24.5525 38.6787 25.2725Z"
          fill="#29BF5B"
        />
      </svg>
    </>
  );
}
